
export const common = {
  'call.us': 'Call Us',
  'privacy.policy': 'Privacy Policy',
  'select.location': 'Select Your Location',
  'location.description': 'Choose your location to call the appropriate number',
  'usa': 'USA',
  'non.usa': 'Non-USA Call or WhatsApp',
  'documents.downloads': 'Documents & Downloads',
  'item': 'Item',
  'value': 'Value',
  'price': 'Price',
  'product': 'Product',
  'msrp': 'MSRP',
};
